const autoNgTemplateLoaderTemplate1 = require('./volumesCifsForm.html');

angular.module('shbdeployer.docker').component('volumesCifsForm', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    data: '=',
  },
});
